export const bottomNavClasses =
  'fixed inset-x-0 bottom-0 z-30 flex border-t border-border bg-surface pb-[env(safe-area-inset-bottom)] lg:hidden';

export const bottomNavItemClasses =
  'flex min-h-11 flex-1 flex-col items-center justify-center gap-0.5 px-1 py-1 text-xs text-content-muted';

export const bottomNavItemActiveClasses = 'text-content';

export const bottomNavIconClasses = 'h-5 w-5';
